<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-login">
        <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
            <vx-card>
                <div slot="no-body" class="full-page-bg-color">

                    <div class="vx-row no-gutter justify-center items-center">

                        <div class="vx-col hidden lg:block lg:w-1/2">
                            <img src="@/assets/images/pages/login.png" alt="login" class="mx-auto">
                        </div>

                        <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
                            <div class="p-8 login-tabs-container">

                                <div class="vx-card__title mb-4">
                                    <div style="float: left">
                                        <h4 class="mb-4">{{ $t("Login") }}</h4>
                                        <p>{{ $t("LoginText") }}</p>
                                    </div>


                                    <i18n :display-text="true" style="float: right"/>

                                    <div style="clear: both"></div>
                                </div>

                                <div>
                                    <div v-if="step === 0">
                                        <vs-input
                                            name="email"
                                            type="email"
                                            icon-no-border
                                            icon="icon-user"
                                            icon-pack="feather"
                                            label-placeholder="Email"
                                            v-model="email"
                                            @keyup.enter="login"
                                            class="w-full mt-12"/>

                                        <vs-input
                                            type="password"
                                            name="password"
                                            icon-no-border
                                            icon="icon icon-lock"
                                            icon-pack="feather"
                                            :label-placeholder="$t('Password')"
                                            v-model="password"
                                            @keyup.enter="login"
                                            class="w-full mt-6"/>

                                        <div class="flex flex-wrap justify-between my-5">
                                            <vs-checkbox v-model="checkbox_remember_me" class="mb-3">
                                                {{ $t("RememberMe") }}
                                            </vs-checkbox>
                                            <router-link to="/resetPass">{{ $t("ForgotPassword") }}</router-link>
                                        </div>
                                    </div>
                                    <div v-else>
                                        <vs-input
                                            name="totp"
                                            type="number"
                                            icon-no-border
                                            icon="icon-hash"
                                            icon-pack="feather"
                                            :label-placeholder="$t('AuthenticatorCode')"
                                            v-model="totp"
                                            @keyup.enter="login"
                                            class="w-full mt-12 mb-8"/>
                                    </div>
                                  <div class="w-full flex flex-wrap justify-between">
                                    <vs-button @click="login" class="mr-4">{{ $t("Login") }}</vs-button>
                                    <vs-button @click="loginWithPasskey" class="py-2 px-4">
                                      <img class="h-6" src="@/assets/images/pages/login/passkey.svg"/>
                                    </vs-button>
                                  </div>

                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </vx-card>
        </div>
    </div>
</template>

<script>

import I18n from "../../layouts/components/navbar/components/I18n"

// eslint-disable-next-line no-undef
const { startAuthentication } = SimpleWebAuthnBrowser;

export default {
    components: {
        I18n,
    },
    data() {
        return {
            email: "",
            password: "",
            totp: "",
            checkbox_remember_me: false,
            step: 0
        }
    },
    methods: {
        login() {
            this.$vs.loading();
            const thisIns = this;
            this.$http.post('/api/v1/login/', {
                email: thisIns.email,
                password: thisIns.password,
                totp: thisIns.totp,
                remember_me: thisIns.checkbox_remember_me
            }).then(function (response) {
                thisIns.$store.dispatch('setLoginStatus', true);
                thisIns.$store.dispatch('updateTheme', response.data.theme);
                thisIns.$store.dispatch('updateUserData', response.data);
                localStorage.setItem('userData', JSON.stringify(response.data));
                thisIns.$vs.loading.close();
                thisIns.$router.push({name: 'ownTasks'});
            }).catch(function (error) {

                thisIns.$vs.loading.close();

                if (error && error.response && error.response.status === 424) {
                    thisIns.step = 1
                    return
                }

                thisIns.$vs.notify({
                    title: 'Error',
                    text: "Login failed",
                    color: 'danger',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle'
                })
            });
        },
      async loginWithPasskey() {

        try {

          const creationRequestResponse = await this.$http.get('/api/v1/login/passkey/start')

          const authenticateResponse = await startAuthentication({
            optionsJSON: creationRequestResponse.data.assertion.publicKey
          })

          if (!authenticateResponse) throw new Error("invalid response")

          const loginResponse = await this.$http.post('/api/v1/login/passkey/finalize', {
            session_id: creationRequestResponse.data.session_id,
            login_response: authenticateResponse
          })

          await this.$store.dispatch('setLoginStatus', true);
          await this.$store.dispatch('updateTheme', loginResponse.data.theme);
          await this.$store.dispatch('updateUserData', loginResponse.data);
          localStorage.setItem('userData', JSON.stringify(loginResponse.data));
          this.$vs.loading.close();
          await this.$router.push({name: 'ownTasks'});

        }catch(error) {
          this.addPasskeyPrompt = false;
          this.$vs.notify({
            title: 'Error',
            text: error,
            color: 'danger',
            iconPack: 'feather',
            icon: 'icon-alert-circle'
          })
        }
      }
    }
}
</script>

<style lang="scss">
</style>
